import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditGlobalRenamingPayload } from '@app-store/slices/eventSettings/editGlobalRenaming'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditGlobalRenamingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventSetting.editGlobalRenaming

function* editGlobalRenamingSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.put(`/event/settings/${payload.settingId}/global-renaming`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Names updated successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editGlobalRenamingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editGlobalRenamingSagaTask)
}

export default editGlobalRenamingSaga
